import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { OrchestrationRunStatus } from '@y42/json-schema';
import { map, Observable } from 'rxjs';
import { OrchestartionRunName } from '../../orchestration-run-name/orchestration-run-name/orchestration-run-name.component';
import { OrchestrationTriggeredBy } from '../../orchestration-triggered-by/orchestration-triggered-by/orchestration-triggered-by.component';

export interface OrchestrationRunDetails {
  runStatus: OrchestrationRunStatus;
  startedAt: Date;
  finishedAt?: Date;
  runName: OrchestartionRunName;
  runId: string;
  triggeredBy: OrchestrationTriggeredBy;
}

@UntilDestroy()
@Component({
  selector: 'y42-orchestration-run-details-stripe[details]',
  templateUrl: './orchestration-run-details-stripe.component.html',
  styleUrls: ['./orchestration-run-details-stripe.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationRunDetailsStripeComponent {
  @Input()
  @InputObservable()
  details?: OrchestrationRunDetails;
  private readonly details$!: Observable<OrchestrationRunDetails | undefined>;

  readonly state = connectState(this, {
    durationRange: this.details$.pipe(
      map((details) => ({ startedAt: details?.startedAt, finishedAt: details?.finishedAt })),
    ),
    runId: this.details$.pipe(map((details) => details?.runId)),
    showStopRunButton: this.details$.pipe(map((details) => details?.runStatus === OrchestrationRunStatus.Pending)),
  });
}
